"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$ABTest = exports.$CurrentABTest = exports.$EnterABTest = void 0;
const jotai_1 = require("jotai");
const merge_1 = __importDefault(require("lodash/merge"));
const uniq_1 = __importDefault(require("lodash/uniq"));
exports.$EnterABTest = (0, jotai_1.atom)({
    versions: '',
    parameters: {},
});
exports.$EnterABTest.debugLabel = '$EnterABTest';
exports.$CurrentABTest = (0, jotai_1.atom)({
    versions: '',
    parameters: {},
});
exports.$CurrentABTest.debugLabel = '$CurrentABTest';
exports.$ABTest = (0, jotai_1.atom)((get) => {
    const enterAbTest = get(exports.$EnterABTest);
    const currentAbTest = get(exports.$CurrentABTest);
    return {
        versions: (0, uniq_1.default)([...enterAbTest.versions.split(','), ...currentAbTest.versions.split(',')]).join(','),
        parameters: (0, merge_1.default)(enterAbTest.parameters, currentAbTest.parameters),
    };
});
exports.$ABTest.debugLabel = '$ABTest';
